import collect from 'collect.js';

const calpak = window.calpak
calpak.collect = collect

async function fetchProducts() {
    // if (typeof collect == "undefined") {
    //     await loadScript(scripts.collect);
    // }
    // /collections/all?view=json excludes product.tags contains "do not display"
    let data = [];
    data = await fetch(
        "/collections/all?view=json&em-default-max-age=300",{
            // "https://www.calpaktravel.com/em-cgi/cache/300/www.calpaktravel.com/collections/all?view=json"
            // cache: "force-cache", // *default, no-cache, reload, force-cache, only-if-cached
        }
    ).then((response) => response.json());
    return data;
}

fetchProducts().then((response) => {
    calpak.products = collect(response.products)
    calpak.collections = collect(response.collections)
    window.calpak.fetchProducts = performance.now().toFixed(0)
    document.dispatchEvent(new Event("products:loaded"))
})
